// Generated by CoffeeScript 2.7.0
require('shared/underscore');
